import script from "./index3.vue?vue&type=script&setup=true&lang=js"
export * from "./index3.vue?vue&type=script&setup=true&lang=js"

import "../../../styles/removeVantcell.css?vue&type=style&index=0&lang=css"
import "./index3.vue?vue&type=style&index=1&id=efda805e&lang=css"
import "./index3.vue?vue&type=style&index=2&id=efda805e&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efda805e"]])

export default __exports__